<template>
  <v-card>
    <v-card-title class="headline">Действительно хотите удалить статус?</v-card-title>

    <v-card-text>
      После удаления, нельзя будет вернуть действие назад
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>

      <v-btn color="warning" text @click="onCloseClicked">Отмена</v-btn>

      <v-btn color="error" text @click="onDeletePerformClicked">Удалить</v-btn>
    </v-card-actions>

    <v-snackbar v-model="isPerformDeletedFailed"
                :timeout="5000"
                :top="true"
                color="error"
    >
      Не удалось удалить статус
    </v-snackbar>
  </v-card>
</template>

<script>
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP} from "@/store/modules/layout/actions";
import MailService from "@/services/mail.service";
import {APP_MAIL_PERFORM_DELETED} from "@/events/app";

export default {
  name: "DeletePerform",
  props: {
    mail: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      isPerformDeletedFailed: false
    }
  },
  methods: {
    onCloseClicked() {
      this.$emit('close')
    },
    onDeletePerformClicked() {
      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START)

      MailService.deletePerform(this.mail.uid)
          .then(() => {
            this.$store.dispatch(APP_MAIL_PERFORM_DELETED, this.mail)
          })
          .catch(() => {
            this.isPerformDeletedFailed = true
          })
          .finally(() => {
            this.$emit('close')
            this.loading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
  }
}
</script>

<style scoped>

</style>
